module.exports = __webpack_public_path__ + "235e6f584f6c1252515f973a4e01f418.png";